// extracted by mini-css-extract-plugin
export default {"player":"Player_player__BbU5W","control":"Player_control__p5zxO","prev":"Player_prev__E-XtD","skip":"Player_skip__yc5FW"};